import script from "./TooltipButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipButtons.vue?vue&type=script&setup=true&lang=js"

import "./TooltipButtons.vue?vue&type=style&index=0&id=24b1aabe&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b1aabe"]])

export default __exports__